export enum ToastType {
    success = 'success',
    warning = 'warning',
    failure='failure',
    neutral='neutral'
}